export const SavedListTabs = [
    {title: 'Industry', id: 'industry-tab', key: '#industry-tab'},
    {title: 'Function', id: 'function-tab', key: '#function-tab'},
    {title: 'Jobs', id: 'jobs-tab', key: '#jobs-tab'},
    {title: 'BD', id: 'bd-tab', key: '#bd-tab'},
    {title: 'CTV', id: 'ctv-tab', key: '#ctv-tab'},
    {title: 'DVTJCUV', id: 'dvtjcuv-tab', key: '#dvtjcuv-tab'},
    {title: 'Others', id: 'others-tab', key: '#others-tab'},
]

export const SavedListTabOptions = SavedListTabs.map(item => {
    return {
        id: item.id,
        value: item.id,
        label: item.title,
        title: item.title,
        key: item.key
    };
})


export const SavedListLevels = [
    '1', '2', '3', '4'
]

export const SavedListLevelsOptions = SavedListTabs.map(item => {
    return {
        value: item,
        label: item
    };
})

export const InitSavedListInfo = {
    tab: '', name: '', notes: '', candidate_ids: [], level: SavedListLevels[0],
}
